var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 16,
    viewBox: "0 0 71 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2047 12.5341V3.03491H20.8V0.777878H30.0594V3.03491H26.6547V12.5341H24.2047V12.5341Z",
    fill: "#0EE06E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6732 12.5341V4.00522H31.9266V5.35522C32.4602 4.20912 33.1481 4.00522 33.8852 4.00522H34.7557V6.29038H34.0186C32.9586 6.29038 32.0109 6.90209 32.0109 8.77241V12.5412H29.6732V12.5341Z",
    fill: "#0EE06E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8157 9.41225V4.00522H38.1464V8.88491C38.1464 9.88334 38.6308 10.6216 39.6276 10.6216C40.5893 10.6216 41.2001 9.88335 41.2001 8.89897V4.00522H43.5307V12.5412H41.3124V11.4654C40.7508 12.3162 39.9154 12.738 38.8554 12.738C36.9881 12.731 35.8157 11.4443 35.8157 9.41225Z",
    fill: "#0EE06E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5276 10.1365L46.5564 9.67241C46.6546 10.3334 47.1811 10.8326 48.199 10.8326C48.9853 10.8326 49.4205 10.5091 49.4205 10.1084C49.4205 9.78491 49.245 9.54585 48.4377 9.37007L47.1039 9.08179C45.3981 8.70913 44.675 7.92163 44.675 6.48726C44.675 5.02476 45.8824 3.84351 48.1499 3.84351C50.5578 3.84351 51.5265 5.29194 51.6248 6.24116L49.582 6.69116C49.4837 6.19194 49.1187 5.64351 48.1008 5.64351C47.4549 5.64351 46.9776 5.93179 46.9776 6.35366C46.9776 6.70523 47.2162 6.9021 47.6374 7.00054L49.582 7.45054C51.0632 7.78804 51.7512 8.67398 51.7512 9.93257C51.7512 11.2826 50.6771 12.7029 48.2131 12.7029C45.5034 12.6959 44.6188 11.0716 44.5276 10.1365Z",
    fill: "#0EE06E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2299 12.5341C54.7207 12.5341 53.7098 11.6974 53.7098 10.038V6.04429H52.2777V3.9982H53.7098V2.09976L56.0404 1.42476V3.9982H57.7603V6.04429H56.0404V9.61617C56.0404 10.2419 56.3633 10.488 56.9881 10.488H57.8867V12.5341H56.2299Z",
    fill: "#0EE06E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1502 12.5341V0.784927H61.4808V12.5412H59.1502V12.5341Z",
    fill: "#0EE06E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5079 4.00522H71L67.4479 15.5997H64.9558L65.9386 12.5412H64.6539L62.3092 4.00522H64.8013L66.5563 10.6076L68.5079 4.00522Z",
    fill: "#0EE06E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799988 5.93148H6.26857V1.55804L10.635 5.93148L6.26857 10.2979V12.5338H11.5687V5.93148H16.4335V0.784607H0.799988V5.93148Z",
    fill: "#0EE06E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustly);
export default __webpack_public_path__ + "static/media/trustly.836ed80f1808d872f3c726a6c28d621a.svg";
export { ForwardRef as ReactComponent };